import styled, { css, keyframes } from 'styled-components/macro'
import { blueGradient, orangeGradient, squircle } from 'src/global/helpers'

type WrapperProps = {
  $isFaded: boolean
}

// A ring that grows out of the badge and fades, like a notification asking to be opened
const badgePulse = keyframes`
  from {
    transform: scale(1);
    opacity: 0.35;
  }
  to {
    transform: scale(1.8);
    opacity: 0;
  }
`

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 100%;
  margin-top: 16px;
  padding: 16px;
  ${squircle(40)}
  background: ${blueGradient};
  box-shadow:
    0 8px 24px rgba(17, 183, 243, 0.22),
    0 2px 6px rgba(17, 183, 243, 0.18);
  color: #ffffff;
  text-align: left;
  transform-origin: center center;
  transition:
    transform 0.337s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.193s ease-in-out 0.095s;

  /* Opening the modal blows the card up toward it, like the other announcement cards */
  ${props =>
    props.$isFaded &&
    css`
      transform: scale(2, 2.8) translate(270px, -90px);
      opacity: 0;
      pointer-events: none;
    `}

  .unread-badge {
    position: absolute;
    top: -8px;
    right: -8px;
    min-width: 28px;
    height: 28px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 14px;
    background: ${orangeGradient};
    border: 2px solid ${props => props.theme.pageBackground};
    box-shadow: 0 4px 12px rgba(255, 122, 80, 0.45);
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
  }

  .unread-badge::after {
    content: '';
    position: absolute;
    inset: -2px;
    border-radius: inherit;
    border: 2px solid #ff8b4d;
    animation: ${badgePulse} 1.8s ease-out infinite;
    pointer-events: none;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      opacity: 0;
    }
  }

  .title {
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
  }

  .launch-age {
    margin: 0 0 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.85);
  }

  /* The age stands out while the launch is recent (up to 10 days) */
  .launch-age b {
    font-weight: 700;
    color: #ffffff;
  }

  .cta {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 12px 16px;
    font-family: inherit;
    color: inherit;
    background: rgba(255, 255, 255, 0.22);
    border: 1px solid rgba(255, 255, 255, 0.35);
    ${squircle(40)}
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .cta:hover {
    background: rgba(255, 255, 255, 0.35);
  }
`
